import {formatDate} from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {BsDatepickerConfig, BsDatepickerDirective, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {EntidadeService} from 'src/app/api/module/erp/services/area-logada/entidade/entidade.service';
import {ListaAuxiliaresService} from 'src/app/api/module/erp/shared/lista-auxiliares/lista-auxiliares.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {VerificaEmail} from 'src/app/components/helper/form-validators/verifica-email';
import {VerificaNome} from 'src/app/components/helper/form-validators/verifica-nome';
import {EnderecoComponent} from 'src/app/pages/area-logada/shared/components/endereco/endereco.component';

@Component({
  selector: 'app-formulario-inscricao-entidade-abje',
  templateUrl: './formulario-inscricao-entidade-abje.component.html',
  styleUrls: ['./formulario-inscricao-entidade-abje.component.scss'],
})
export class FormularioInscricaoEntidadeAbjeComponent implements OnInit, OnChanges {
  @ViewChild('datepickerBirthDate', {static: false}) datepickerBirthDate?: BsDatepickerDirective;
  @ViewChild('datepickerExerciseStartDate', {static: false}) datepickerExerciseStartDate?: BsDatepickerDirective;
  @ViewChild('datepickerAdmissionDate', {static: false}) datepickerAdmissionDate?: BsDatepickerDirective;
  @ViewChild(EnderecoComponent) enderecoComponent: EnderecoComponent;

  @Output() aoFecharModalInscricao = new EventEmitter<boolean>();
  @Input() retornoDadosFormularioEntidade: any;
  @Input() formEntidadeSomenteLeitura: boolean = false;
  @Input() nomeEntidade!: any;
  @Input() logoEntidade!: any;

  formularioInscricaoEntidadeABJE!: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  isFormSubmited = false;
  ListaServidores!: any;
  minDate!: Date;
  maxDate!: Date;
  listaEstatusCivil = new Array<any>();
  listaProduto = new Array<any>();
  listaDoQuadro = new Array<any>();
  listaEnvioCorrespondencia = new Array<any>();
  idProposta: string = '';
  produtoSelecionado: string = '';
  formTouched: boolean = false;
  errorMessage: boolean = false;
  inputDataSelecionado: boolean = false;
  menssagemErroCampoData: string | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private _spinnerService: SpinnerService,
    private bsLocaleService: BsLocaleService,
    private _listaAux: ListaAuxiliaresService,
    private toastr: ToastrService,
    private _entidadeService: EntidadeService,
    private _activeRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    this.bsLocaleService.use('pt-br');
    this.minDate = new Date(1900, 0, 1);
    this.maxDate = new Date();
    this.bsConfig = {
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      maxDate: new Date(),
    };
    this.criarFormulario();
  }

  ngOnInit(): void {
    this.buscarListaEstatusCivil();
    this.carregarListas();
    if (this.formEntidadeSomenteLeitura) {
      this.formularioInscricaoEntidadeABJE.disable();
    } else {
      this.formularioInscricaoEntidadeABJE.enable();
    }
    this.idProposta = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['retornoDadosFormularioEntidade'] && this.retornoDadosFormularioEntidade) {
      this.carregarDadosFormulario(this.retornoDadosFormularioEntidade);
    }
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  private criarFormulario(): void {
    this.formularioInscricaoEntidadeABJE = this.formBuilder.group({
      id: new FormControl('', [Validators.maxLength(100)]),
      proposalId: new FormControl('', [Validators.maxLength(100)]),
      memberNumber: new FormControl('', [Validators.maxLength(250)]),
      admissionDate: new FormControl(''),
      name: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(250),
        VerificaNome,
      ]),
      treBadge: new FormControl('', [Validators.maxLength(250)]),
      birthDate: new FormControl(null, Validators.required),
      sex: new FormControl(null, [Validators.required]),
      civilStatusId: new FormControl(null, [Validators.required, Validators.maxLength(250)]),
      rg: new FormControl('', [Validators.required, Validators.maxLength(250)]),
      cpf: new FormControl('', [Validators.required, Validators.maxLength(250)]),
      motherName: new FormControl('', [Validators.maxLength(250)]),
      fatherName: new FormControl('', [Validators.maxLength(250)]),
      homePhone: new FormControl('', [Validators.maxLength(250)]),
      mobilePhone: new FormControl('', [Validators.maxLength(250), Validators.required]),
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.minLength(2),
        Validators.maxLength(250),
        VerificaEmail,
      ]),
      boardStatus: new FormControl(null),
      position: new FormControl('', [Validators.maxLength(250)]),
      commissionedRole: new FormControl('', [Validators.maxLength(250)]),
      exerciseStartDate: new FormControl('', [Validators.maxLength(250)]),
      workUnit: new FormControl('', [Validators.maxLength(250)]),
      treBuildingFloor: new FormControl('', [Validators.maxLength(250)]),
      workPhone: new FormControl('', [Validators.maxLength(250)]),
      correspondenceOption: new FormControl(null),
      receiveMarketingEmails: new FormControl(null),
      paymentAuthorization: new FormControl(null),
      bankName: new FormControl('', [Validators.maxLength(250)]),
      agencyName: new FormControl('', [Validators.maxLength(250)]),
      agencyNumber: new FormControl('', [Validators.maxLength(10)]),
      currentAccountNumber: new FormControl('', [Validators.maxLength(250)]),
      productGeiaUnimedFesp: new FormControl('', [Validators.maxLength(250)]),
      productDental: new FormControl(null),
      productAnserjufe: new FormControl(null),
      productLegalAndBond: new FormControl(null),
      productOtherPartnerships: new FormControl(null),
      produtoEscolhido: new FormControl(null),
    });
  }

  private carregarListas(): void {
    this._entidadeService.listasCamposFormularioABJE().subscribe((data: any) => {
      this.listaProduto = data?.produtos || [];
      this.listaDoQuadro = data?.doQuadro || [];
      this.listaEnvioCorrespondencia = data?.envioCorrespondencia || [];
    });
  }

  private carregarDadosFormulario(dados: any): void {
    if (!dados) {
      return;
    }

    if (!this.formularioInscricaoEntidadeABJE) {
      this.criarFormulario();
    }

    try {
      // Função auxiliar para evitar o erro de fuso horário em strings YYYY-MM-DD
      const parseDate = (dateString: string) => {
        if (!dateString) return null;
        // Se a data vier apenas como YYYY-MM-DD, adicionamos o horário para forçar o fuso local
        if (dateString.length === 10) {
          return new Date(dateString + 'T00:00:00');
        }
        return new Date(dateString);
      };

      this.formularioInscricaoEntidadeABJE.patchValue({
        proposalId: dados.proposalId || '',
        civilStatusId: dados.civilStatusId || '',
        name: dados.name || '',
        admissionDate: parseDate(dados.admissionDate) || '',
        birthDate: parseDate(dados.birthDate) || '',
        exerciseStartDate: parseDate(dados.exerciseStartDate) || '',
        cpf: dados.cpf || '',
        rg: dados.rg || '',
        email: dados.email || '',
        sex: dados.sex || null,
        homePhone: dados.homePhone || '',
        mobilePhone: dados.mobilePhone || '',
        memberNumber: dados.memberNumber || '',
        treBadge: dados.treBadge || '',
        motherName: dados.motherName || '',
        fatherName: dados.fatherName || '',
        boardStatus: dados.boardStatus,
        position: dados.position || '',
        commissionedRole: dados.commissionedRole || '',
        workUnit: dados.workUnit || '',
        treBuildingFloor: dados.treBuildingFloor || '',
        workPhone: dados.workPhone || '',
        correspondenceOption: dados.correspondenceOption,
        receiveMarketingEmails: dados.receiveMarketingEmails,
        paymentAuthorization: dados.paymentAuthorization,
        bankName: dados.bankName || '',
        agencyName: dados.agencyName || '',
        agencyNumber: dados.agencyNumber || '',
        currentAccountNumber: dados.currentAccountNumber || '',
        productGeiaUnimedFesp: dados.productGeiaUnimedFesp || '',
        productDental: dados.productDental || '',
        productAnserjufe: dados.productAnserjufe || '',
        productLegalAndBond: dados.productLegalAndBond || '',
        productOtherPartnerships: dados.productOtherPartnerships || '',
      });

      setTimeout(() => {
        this.processarSelecaoDeProduto();
        this.enderecoComponent.preencherFormComponenteSemTabela(dados);
      }, 100);
      this.cdRef.detectChanges();
    } catch (error) {}
  }

  private buscarListaEstatusCivil() {
    this._listaAux.LitaEstadosCivil().subscribe(data => {
      this.listaEstatusCivil = data && data;
    });
  }

  onFieldChange() {
    if (this.formTouched) {
      this.errorMessage = !this.isFormValid();
    }
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formularioInscricaoEntidadeABJE.valid;
  }

  salvar() {
    this.iniciarSpinner();
    this.formTouched = true;
    const debitoCC = this.formularioInscricaoEntidadeABJE.controls['paymentAuthorization'].value;
    const nomeBanco = this.formularioInscricaoEntidadeABJE.controls['bankName'].value;

    if (this.enderecoComponent) {
      this.enderecoComponent.formTouched = true;
      this.enderecoComponent.isFormSubmited = true;
      this.enderecoComponent.showErrorMessage = true;
    }

    if (!this.formularioInscricaoEntidadeABJE.valid) {
      this.isFormSubmited = true;
      this.toastr.warning('Por favor, verifique todos os campos obrigatórios.');
      this.toastr.toastrConfig.preventDuplicates = true;
      this.pararSpinner();
      return;
    }
    const formEndereco = this.enderecoComponent?.isFormValid() ?? true;
    if (!formEndereco) {
      this.toastr.warning('Por favor, verifique todos os campos obrigatórios.');
      this.toastr.toastrConfig.preventDuplicates = true;
      this.pararSpinner();
      return;
    }
    const algumProdutoSelecionado = this.listaProduto.some(item => item.valor === true);

    if (!algumProdutoSelecionado) {
      this.toastr.warning('Por favor, selecione um produto.');
      this.toastr.toastrConfig.preventDuplicates = true;
      this.pararSpinner();
      return;
    }

    if (debitoCC == 1 && nomeBanco != 'Banco do Brasil') {
      this.toastr.warning(
        'Débito em conta corrente exige conta no Banco do Brasil. Verifique o banco informado ou opte por débito em folha.',
      );
      this.toastr.toastrConfig.preventDuplicates = true;
      this.pararSpinner();
      return;
    }

    this.formularioInscricaoEntidadeABJE.patchValue({
      productGeiaUnimedFesp: true,
      productDental: false,
      productAnserjufe: false,
      productLegalAndBond: false,
      productOtherPartnerships: false,
    });
    this.formularioInscricaoEntidadeABJE.get('proposalId')?.patchValue(this.idProposta);

    // const produtoSelecionado = this.listaProduto.find(item => item.valor === true);

    // // Atualizar o produto correspondente no formulário
    // if (produtoSelecionado) {
    //   this.formularioInscricaoEntidadeABJE.patchValue({
    //     [produtoSelecionado.nome]: true,
    //   });
    // }

    const formularioEnderco = this.enderecoComponent?.enderecoForm.value;
    delete formularioEnderco['id'];
    delete formularioEnderco['active'];
    const formData = {
      ...this.formularioInscricaoEntidadeABJE.value,
      ...formularioEnderco,
    };
    // Formatar admissionDate para DateOnly (YYYY-MM-DD)
    if (formData.admissionDate) {
      formData.admissionDate = this.formatarParaDateOnly(formData.admissionDate);
    }

    // Formatar exerciseStartDate para DateOnly (YYYY-MM-DD)
    if (formData.exerciseStartDate) {
      formData.exerciseStartDate = this.formatarParaDateOnly(formData.exerciseStartDate);
    }
    // this.pararSpinner();
    // return;

    this._entidadeService
      .cadastrarFormInscricaoEntidadeABJE(formData)
      .pipe(finalize(() => this.pararSpinner(1000)))
      .subscribe({
        next: async (data: any) => {
          this.toastr.success('Dados Cadastrados!');
          this.aoFecharModalInscricao.emit(true);
        },
        error: (e: any) => {
          this.toastr.toastrConfig.preventDuplicates = true;
          this.toastr.error(e.message);
          this.pararSpinner();
        },
      });
  }

  private formatarParaDateOnly(data: any): string {
    if (!data) return '';

    try {
      return formatDate(data, 'yyyy-MM-dd', 'pt-BR');
    } catch (error) {
      this.toastr.warning('Erro ao formatar data');
      return '';
    }
  }

  fechar(): void {
    // Marca todos os campos como tocados para validar
    this.marcarCamposComoTocados();
    // Verifica se foi preenchido (dirty) E válido
    const formularioPreenchidoEValido =
      this.formularioInscricaoEntidadeABJE.dirty && this.formularioInscricaoEntidadeABJE.valid;
    this.aoFecharModalInscricao.emit(formularioPreenchidoEValido);
  }

  private marcarCamposComoTocados(): void {
    Object.keys(this.formularioInscricaoEntidadeABJE.controls).forEach(campo => {
      this.formularioInscricaoEntidadeABJE.get(campo)?.markAsTouched();
    });
  }

  private processarSelecaoDeProduto(): void {
    // Verificar se a lista de produtos já foi carregada
    if (!this.listaProduto || this.listaProduto.length === 0) {
      this.toastr.warning('Lista de produtos ainda não carregada');
      return;
    }

    // Verificar qual propriedade de produto está como true no formulário
    const produtosDoFormulario = [
      'productGeiaUnimedFesp',
      'productDental',
      'productAnserjufe',
      'productLegalAndBond',
      'productOtherPartnerships',
    ];

    let produtoSelecionadoNome = '';

    for (const produtoNome of produtosDoFormulario) {
      const valorProduto = this.formularioInscricaoEntidadeABJE.get(produtoNome)?.value;

      if (valorProduto === true) {
        produtoSelecionadoNome = produtoNome;
        break;
      }
    }

    if (produtoSelecionadoNome) {
      this.selecionarProdutoNaLista(produtoSelecionadoNome);

      this.formularioInscricaoEntidadeABJE.patchValue({
        produtoEscolhido: produtoSelecionadoNome,
      });
    }
  }

  private selecionarProdutoNaLista(produtoNome: string): void {
    this.listaProduto.forEach(item => {
      item.valor = false;
    });

    const produtoNaLista = this.listaProduto.find(item => item.nome === produtoNome);
    if (produtoNaLista) {
      produtoNaLista.valor = true;
      this.produtoSelecionado = produtoNome;
    }
  }

  selecionarProduto(produtoSelecionado: any): void {
    if (produtoSelecionado.valor === true) {
      return;
    }

    this.listaProduto.forEach(item => {
      item.valor = false;
    });

    produtoSelecionado.valor = true;
    this.produtoSelecionado = produtoSelecionado.nome;

    this.formularioInscricaoEntidadeABJE.patchValue({
      produtoEscolhido: produtoSelecionado.nome,
    });

    this.atualizarCamposDeProdutoNoFormulario(produtoSelecionado.nome);
  }

  private atualizarCamposDeProdutoNoFormulario(produtoNome: string): void {
    // Lista de todas as propriedades de produto
    const todosProdutos = [
      'productGeiaUnimedFesp',
      'productDental',
      'productAnserjufe',
      'productLegalAndBond',
      'productOtherPartnerships',
    ];

    // Definir todos os produtos como false
    todosProdutos.forEach(nome => {
      this.formularioInscricaoEntidadeABJE.get(nome)?.patchValue(false);
    });

    // Definir apenas o produto selecionado como true
    this.formularioInscricaoEntidadeABJE.get(produtoNome)?.patchValue(true);
  }

  private getCampoData(campoId: string | number): HTMLInputElement & {datepickerInstance?: any} {
    const id = typeof campoId === 'number' ? `dependente-${campoId}` : campoId;
    return document.getElementById(id) as HTMLInputElement & {
      datepickerInstance?: any;
    };
  }

  campoDataSelecionado(event: FocusEvent, campoId: string) {
    this.inputDataSelecionado = true;
    const eventoCampoData = event.target as HTMLInputElement;
    this.esconderCalendario(campoId);

    if (eventoCampoData && eventoCampoData.value === 'Data inválida') {
      eventoCampoData.value = '';
      this.menssagemErroCampoData = null;
    }
  }

  esconderCalendario(campoId?: string) {
    if (!campoId || !this.inputDataSelecionado) return;

    const datepicker = this.getDatepickerPorCampo(campoId);
    if (datepicker) {
      datepicker.hide();
    }
  }

  mostrarCalendario(campoId: string) {
    this.inputDataSelecionado = false;
    const datepicker = this.getDatepickerPorCampo(campoId);

    if (datepicker) {
      if (datepicker.isOpen) {
        datepicker.hide();
      } else {
        datepicker.show();
      }
    }
  }

  private getDatepickerPorCampo(campoId: string): BsDatepickerDirective | undefined {
    switch (campoId) {
      case 'birthDate':
        return this.datepickerBirthDate;
      case 'exerciseStartDate':
        return this.datepickerExerciseStartDate;
      case 'admissionDate':
        return this.datepickerAdmissionDate;
      default:
        return undefined;
    }
  }

  formatarCampoData(valor: string, campoId: string | number): string {
    this.onFieldChange();
    const elementoCampoData = this.getCampoData(campoId);
    const valorCampo = valor?.toString() ?? '';
    const dataHoje = new Date();
    dataHoje.setHours(0, 0, 0, 0);

    let dataInformada = new Date(valorCampo);
    dataInformada.setHours(0, 0, 0, 0);

    if ((valorCampo && isNaN(Date.parse(valorCampo))) || dataInformada > dataHoje) {
      this.menssagemErroCampoData = 'Data inválida';
      setTimeout(() => {
        elementoCampoData.value = 'Data inválida';
        this.menssagemErroCampoData = null;
      }, 0);
      return '';
    }

    const apenasNumeros = valorCampo.replace(/\D/g, '');

    if (apenasNumeros.length <= 2) {
      return apenasNumeros;
    } else if (apenasNumeros.length <= 4) {
      return `${apenasNumeros.slice(0, 2)}/${apenasNumeros.slice(2)}`;
    } else {
      return `${apenasNumeros.slice(0, 2)}/${apenasNumeros.slice(2, 4)}/${apenasNumeros.slice(4)}`;
    }
  }
}
